/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submit_Ad_JobInputs */



/**
* | output |
* | --- |
* | "Submit AD Job" |
*
* @param {Submit_Ad_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_ad_job = /** @type {((inputs?: Submit_Ad_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Ad_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soumettre une offre d'emploi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stellenanzeige einreichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia un annuncio di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправить объявление о вакансии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar anuncio de empleo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("提交广告职位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("広告掲載求人")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नौकरी के लिए विज्ञापन जमा करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviar anúncio de emprego")
	return /** @type {LocalizedString} */ ("Submit AD Job")
});